import { getWalletClient } from '@wagmi/core';
import { toBytes } from 'viem';
import type { HorusSigner } from './types';

export function createNonCustodialSigner(address: string): HorusSigner {
  const normalizedAddress = address.toLowerCase();

  return {
    type: 'EOA',
    getIdentifier: () => ({
      identifier: normalizedAddress,
      identifierKind: "Ethereum" as const,
    }),
    signMessage: async (message: string): Promise<Uint8Array> => {
      const walletClient = await getWalletClient();
      if (!walletClient) {
        throw new Error('No wallet client available. Please connect your wallet.');
      }
      const signature = await walletClient.signMessage({
        account: address as `0x${string}`,
        message,
      });
      return toBytes(signature);
    },
  };
}
